<div class="block-shadow position-relative"
  [class.bg-history]="info.type === 'HISTORY'"
  [class.bg-draft]="info.draft"
  [class.bg-white]="info.type !== 'HISTORY' && !info.draft"
  [class.red-border]="isFirst && info.type === 'DIRECT'">
  <div class="d-flex flex-md-row flex-column position-relative" [class.title-admin]="adminMode">
    <h3 class="me-3 pb-2 fw-bold" [id]="info.title">
      @if (isFirst && info.type === 'DIRECT') {
        <fa-icon class="text-red" icon="bell"></fa-icon>
      }
      @if (info.type === 'PINNED') {
        <fa-icon class="text-info" icon="thumbtack"></fa-icon>
      }
      @if (info.type !== 'DIRECT' && info.type !== 'PINNED') {
        <span></span>
      }
      {{ info.title }}
    </h3>
    <div class="badges">
      @for (label of info.labels; track label) {
        <app-badge class="me-3" [label]="label"></app-badge>
      }
      @for (category of info.categories | filtercategorywithperm:adminMode | async; track category) {
        <span>
          <app-badge class="me-3" [label]="category"></app-badge>
        </span>
      }
    </div>
  </div>
  <div class="pb-2" [innerHTML]="html"></div>
  <div class="fst-italic text-light-grey">
    @if (info.draft) {
      Brouillon
    }
    @if (!info.draft) {
      Publiée le {{ info.publication | date:'dd/MM/yyyy à HH' }}h{{ info.publication | date:'mm' }}
    }
    @if(adminMode && info.endDate) {
      <div>
        Fin de publication le {{ info.endDate | date:'dd/MM/yyyy' }}
      </div>
    }
  </div>
  @if (adminMode) {
    <span class="position-absolute">
      @if (info.draft) {
        <fa-icon ngbTooltip="Publier" size="lg" class="me-3 cursor-pointer text-success" icon="plus"
        (click)="publish.emit()"></fa-icon>
      }
      <fa-icon ngbTooltip="Modifier" size="lg" class="me-3 cursor-pointer text-primary" icon="pen"
      (click)="edit.emit()"></fa-icon>
      @if (info.type !== 'HISTORY') {
        <fa-icon ngbTooltip="Basculer dans l'historique" size="lg" class="me-3 cursor-pointer text-warning"
        icon="history" (click)="history.emit()"></fa-icon>
      }
      @if (info.type === 'HISTORY') {
        <fa-icon ngbTooltip="Archiver" size="lg" class="me-3 cursor-pointer text-warning"
        icon="archive" (click)="archive.emit()"></fa-icon>
      }
    </span>
  }
</div>
